<template>
    <md-modal-dialog v-slot="{ title, queries }">

      <md-dialog-title>{{ title }}</md-dialog-title>

      <md-dialog-content>

        <template v-for="[name, type] in Object.entries(queries)">
          
          <md-field v-if="type==String" :key="name">
            <label>{{ name }}</label>
            <md-input v-model="data[name]"></md-input>
          </md-field>

        </template>

      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-flat" @click="onCancel">Cancel</md-button>
        <md-button class="md-primary md-flat" @click="onOK">OK</md-button>
      </md-dialog-actions>

    </md-modal-dialog>
</template>

<script>

import ValidatedInputs from '@/components/ValidatedInput';
import { LoginCard } from "@/components";

export default {
  components: {
    ...ValidatedInputs,
    LoginCard,
  },
  props: {},
  computed: {},
  data() {
    return {
      data: {},
    };
  },
  methods: {
    onCancel(){
      this.$modal.cancel()
    },
    onOK(){
      this.$modal.submit(this.data)
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";

  .md-subheader {
    padding: 0px;
  }

</style>
